module.exports = __webpack_public_path__ + "static/media/showtime-powered-logo-2x.71b17d5d.png";